import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ArrowAbortIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M13.4101 12L23.7101 1.71C24.1001 1.32 24.1001 0.689999 23.7101 0.299999C23.3201 -0.0900005 22.6901 -0.0900005 22.3001 0.299999L12.0101 10.59L1.71006 0.289999C1.32006 -0.100001 0.680059 -0.100001 0.290059 0.289999C-0.0999414 0.679999 -0.0999414 1.32 0.290059 1.71L10.5801 12L0.290059 22.29C-0.0999414 22.68 -0.0999414 23.31 0.290059 23.7C0.680059 24.09 1.31006 24.09 1.70006 23.7L11.9901 13.41L22.2801 23.7C22.6701 24.09 23.3001 24.09 23.6901 23.7C24.0801 23.31 24.0801 22.68 23.6901 22.29L13.4001 12H13.4101Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ArrowAbortIcon.displayName = 'ArrowAbortIcon';
